import React from "react"
import { useNavigate } from "react-router-dom"

const CaptainPage = () => {
  const navigate = useNavigate()

  const handleSubmit = () => {
    // yaha baad me API call ayega
    navigate("/my-teams")
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Select Captain</h2>

      <button
        onClick={handleSubmit}
        className="bg-green-500 text-theme-text px-4 py-2 rounded"
      >
        Join Contest
      </button>
    </div>
  )
}

export default CaptainPage